import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerRequestRangeLookupComponent } from './customer-request-range-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule
  ],
  declarations: [CustomerRequestRangeLookupComponent],
  exports : [CustomerRequestRangeLookupComponent]
})
export class CustomerRequestRangeLookupModule { }
